import {createSlice} from "@reduxjs/toolkit";

const initialNoticeState = {
    listLoading: false,
    actionsLoading: false,
    totalCount: 0,
    entities: null,
    noticeToView: undefined,
    lastError: null
}


export const callTypes = {
    list: "list",
    action: "action"
}


export const noticesSlice = createSlice({
    name: "notices",
    initialState: initialNoticeState,
    reducers: {
        catchError: (state, action) => {
            state.error = `${action.type}: ${action.payload.error}`;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = false;
            } else {
                state.actionsLoading = false;
            }
        },
        startCall: (state, action) => {
            state.error = null;
            if (action.payload.callType === callTypes.list) {
                state.listLoading = true;
            } else {
                state.actionsLoading = true;
            }
        },
        
        // find Notices
        
        noticesFetched: (state, action) => {
            const {totalCount, entities} = action.payload;
            state.listLoading = false;
            state.error = null;
            state.entities = entities;
            state.totalCount = totalCount;
        },

        noticeFetched: (state, action) => {
            state.actionsLoading = false;
            state.noticeToView = action.payload.noticeToView;
            state.error = null;
        },

        // create Notice
        noticeCreated: (state, action) => {
            state.actionsLoading = false;
            state.error = null;
            state.entities.unshift(action.payload.notice);
        },
        noticeDeleted: (state, action) => {
            state.actionsLoading = false;
            state.error = null;
            state.entities = state.entities.filter(el => el.id !== action.payload.id);
        }
    }
})